import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import Loader from './../../components/Loader/Loader'
import Recommended from '../../components/FeedingGuidelines/Recommended/Recommended';
import fetchFeedingGuidelinesRecommendedAction from './../../store/actions/fetch/fetchFeedingGuidelinesRecommendedAction';
import * as actionTypes from './../../store/actions/feedingGuidelinesRecommendedAction';
import * as pdfOutputAction from './../../store/actions/pdfOutputAction';
import domtoimage from 'dom-to-image';
import OnImagesLoaded from 'react-on-images-loaded';
import {getDateFormat} from './../../helpers/DateHelper';
import moment from 'moment';


class FeedingGuidelinesRecommended extends Component {

  componentDidMount() {
    const {fetchData, derData, dailyWetReducerAmounts, mealsPerDay} = this.props;

    // DER
    const {
      speciesId,
      breedId,
      sterilisedId,
      currentBodyWeight,
      goalWeight,
      bodyConditionScore,
      durationId,
      intensityFieldId,
      environmentTemperature,
    } = this.props;
    let {
      pregnancyId,
      lactationId,
      litterSize,
      birth,
      products,
      diagnosesIds,
      isWeightAdjustment,
      isCriticalCare,
      isMale,
      isAnorexia
    } = this.props;
    if (isWeightAdjustment === null || isWeightAdjustment === false){
      isWeightAdjustment = 0;
    }
    else{
      isWeightAdjustment = 1;
    }
    if (isCriticalCare === null || isCriticalCare === false){
      isCriticalCare = 0;
    }
    else{
      isCriticalCare = 1;
    }
    if (isMale === null || isMale === false || isMale == "female"){
      isMale = 0;
    }
    else{
      isMale = 1;
    }
    if (pregnancyId ===null){
      pregnancyId = -1;
    }
    if (lactationId ===null){
      lactationId = -1;
    }
    if (litterSize ===null){
      litterSize = -1;
    }
    if (birth ===null){
      birth = -1;
    }

    products = JSON.stringify(products);
    diagnosesIds = JSON.stringify(diagnosesIds);

    fetchData(
      derData.casuistic,
      dailyWetReducerAmounts,
      mealsPerDay,
      speciesId,
      breedId,
      birth,
      isMale,
      sterilisedId,
      pregnancyId,
      lactationId,
      litterSize,
      currentBodyWeight,
      goalWeight,
      bodyConditionScore,
      isWeightAdjustment,
      durationId,
      intensityFieldId,
      environmentTemperature,
      diagnosesIds,
      isCriticalCare,
      products,
      isAnorexia
    );
  }

  doScreenShot() {
    const {screenshots}  = this.props;
    const el = document.getElementById('fc-screenshot-feeding-guidelines-recommended');
    const {setScreenShot, onScreenshotError} = this.props;
    if (el){
      domtoimage.toPng(el)
        .then(function (dataUrl) {
          if (screenshots && screenshots['fc-screenshot-feeding-guidelines-recommended'] !== dataUrl){
            setScreenShot(dataUrl);
          }
        })
        .catch(function () {
          onScreenshotError();
        });
    } else {
      onScreenshotError();
    }
  }

  render() {
    const {data, casuistic, mealsPerDay, pending, ready, error} = this.props;

    if(pending || !ready) return (
      <Loader/>
    );

    return (
      <OnImagesLoaded
        onLoaded={this.doScreenShot.bind(this)}
        onTimeout={this.doScreenShot.bind(this)}
        timeout={7000}>
        <Recommended
          data={data}
          casuistic={casuistic}
          mealsPerDay={mealsPerDay}
        />;
      </OnImagesLoaded>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.feedingGuidelinesRecommendedReducer.data,
    pending: state.feedingGuidelinesRecommendedReducer.pending,
    ready: state.feedingGuidelinesRecommendedReducer.ready,
    error: state.feedingGuidelinesRecommendedReducer.error,
    screenshots: state.pdfOutputReducer.images,
    derData: state.calculateDerReducer.data,
    mealsPerDay: state.petInfoReducer.mealsPerDay,
    dailyWetReducerAmounts: state.dailyWetReducer.amounts,
    casuistic: state.calculateDerReducer.data.casuistic,

    //DER Calculation
    speciesId: state.animalTypeReducer.selectedId,
    breedId: state.breedReducer.selectedData.id,
    birth: state.birthDateReducer.selected,
    isMale: state.genderReducer.selected,
    sterilisedId: state.weeksLitterReducer.sterilisedFactorId,
    pregnancyId: state.weeksLitterReducer.pregnancyFactorId,
    lactationId: state.weeksLitterReducer.lactationFactorId,
    litterSize: state.weeksLitterReducer.selectedLitter,
    currentBodyWeight: state.bodyConditionReducer.selectedBodyWeight,
    goalWeight: state.bodyConditionReducer.selectedGoalWeight,
    bodyConditionScore: state.conditionScoreReducer.selected,
    isWeightAdjustment: state.weightAdjustmentReducer.selected,
    durationId: state.physicalActivityReducer.selectedDurationId,
    intensityFieldId: state.physicalActivityReducer.selectedIntensity,
    environmentTemperature: state.physicalActivityReducer.selectedTemperature,
    diagnosesIds: state.diagnosesReducer.selectedIds,
    isCriticalCare: state.criticalCareReducer.selected,
    products: state.productsReducer.selected,
    isAnorexia: state.criticalCareReducer.selectedAnorexia,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchFeedingGuidelinesRecommendedAction
      },
      dispatch,
    ),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
    setScreenShot: (data) => dispatch({
      type: pdfOutputAction.ADD,
      key: 'fc-screenshot-feeding-guidelines-recommended',
      data: data,
    }),
    onScreenshotError: () => dispatch({
      type: pdfOutputAction.SCREENSHOT_ERROR,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedingGuidelinesRecommended);
